<div class="troubleshoot-container flex-start-center ui-g-12" [hidden]="!troubleShootCode?.length">
  <div class="troubleshoot-container-left ui-g-3 p-0">
    <div class="troubleshoot-list">
      <div class="troubleshoot-list-item flex-start-center p-2" *ngFor="let code of troubleShootCode"
        (click)="getTroubleshootDetails(code?.applicationId)">
        <div class="flex-column">
          <p class="m-0 font-600">{{code?.displayName}}</p>
          <p class="m-0">{{code?.description}}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="troubleshoot-container-right repair-diagram-wrapper flex-end-center ui-g-9 p-0" [hidden]="isLoading">
    <div class="troubleshoot-right-wrapper">
      <div class="image-viewer-counter-wrapper" *ngIf="documentUrls?.length > 1">
        <span class="font-18 font-gray-45 font-600">{{imageIndex + 1}} of {{documentUrls?.length}}</span>
      </div>

      <angular-image-viewer *ngIf="documentUrls?.length && contentType === 'image'" [(index)]="imageIndex"
        [src]="documentUrls" [config]="config">
      </angular-image-viewer>

      <object [hidden]="contentType !== 'pdf'" type="application/pdf" width="100%" height="100%" id="trouble-code-pdf">
        <p>Can't preview file, try <a [href]="pdfDocument">download PDF</a></p>
      </object>
    </div>
  </div>

  <div class="troubleshoot-container-right repair-diagram-wrapper flex-end-center ui-g-9 p-0" [hidden]="!isLoading">
    <div class="troubleshoot-right-wrapper flex-start-start p-2">
      <span class="pr-2">Loading</span>
      <i class="fal fa-spinner rotate"></i>
    </div>
  </div>
</div>

<div class="troubleshoot-container flex-start-center ui-g-12" [hidden]="troubleShootCode?.length">
  <div class="troubleshoot-container-empty pt-5">
    <div class="flex-start-center flex-column width-100p" [hidden]="isLoading">
      <i class="fal fa-engine-warning font-26 mb-2 pt-5"></i>

      <p class="mb-2">Enter a code in the search box above for diagnostic results</p>
    </div>

    <div class="flex-start-center flex-column width-100p" [hidden]="!isLoading">
      <div class="troubleshoot-right-wrapper flex-start-center p-2">
        <span class="pr-2">Loading</span>
        <i class="fal fa-spinner rotate"></i>
      </div>
    </div>
  </div>
</div>
